exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar[data-v-28713ac9]{height:60px;overflow:hidden;position:relative;border-bottom:1px solid #dcdfe6;-webkit-box-sizing:border-box;box-sizing:border-box}.navbar .hamburger-container[data-v-28713ac9]{line-height:60px;height:100%;float:left;cursor:pointer;-webkit-transition:background .3s;transition:background .3s;-webkit-tap-highlight-color:transparent}.navbar .hamburger-container[data-v-28713ac9]:hover{background:rgba(0,0,0,.025)}", ""]);

// exports
